import { useContext } from 'react';

import { FilterContext } from './FilterContextBase';

import type { FilterContextType } from './types';

export const useFilter = (): FilterContextType => {
  const context = useContext(FilterContext);
  if (context === undefined) {
    throw new Error('useFilter must be used within a FilterProvider');
  }
  return context;
};
